import { StepType } from '@de/types/enums';
import { Component, DCS, Step, Question } from '@de/types/types';
import { formatGrainToken } from '@de/utils/stepGrain';

// Function to determine format types
export const getTypeInfo = (
  currentStepType: string | undefined,
  currentStep: Step,
): { formatType: string; formatSubtype: string } => {
  if (!currentStepType) {
    return { formatType: '', formatSubtype: '' };
  }
  const formattedType = formatGrainToken(currentStepType);

  const formatType = currentStep?.isEntry
    ? `dexp-entry-${formattedType}`
    : `dexp-${formattedType}`;

  let formatSubtype: string;

  switch (currentStepType) {
    case StepType.COMPONENT: {
      const componentToken = formatGrainToken(
        (currentStep as Component).componentType,
      );
      if (componentToken) {
        formatSubtype = `dexp-${componentToken}`;
      } else {
        // DSL-rendered components leave `componentType` empty (they render
        // via the generic DSL renderer). Recover the entry/result grain
        // from the resolved DSL config instead of emitting a bare `dexp-`.
        const dslType = formatGrainToken(
          (currentStep as Component).dslConfig?.type,
        );
        formatSubtype = dslType ? `dexp-dsl-${dslType}` : 'dexp-unknown';
      }
      break;
    }
    case StepType.QUESTION: {
      const questionToken = formatGrainToken(
        (currentStep as Question).questionType,
      );
      formatSubtype = questionToken ? `dexp-${questionToken}` : 'dexp-unknown';
      break;
    }
    case StepType.MULTI_QUESTION:
      formatSubtype = `dexp-multi-question`;
      break;
    case StepType.DCS: {
      const variantToken = formatGrainToken((currentStep as DCS).variant);
      formatSubtype = variantToken ? `dexp-${variantToken}` : 'dexp-unknown';
      break;
    }
    case StepType.BANNER_CTA:
      // TODO: Confirm if these are the correct values
      formatSubtype = 'dexp-banner-cta';
      break;
    default:
      formatSubtype = `dexp-unknown`;
      break;
  }

  return { formatType, formatSubtype };
};
